import { render } from "./App.vue?vue&type=template&id=fd0bce4c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fd0bce4c&lang=scss"
script.render = render

export default script